import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E5E5] bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <p className="font-cabinet font-bold text-[#0A0A0A] text-lg tracking-tight">
              The AI Mastery Series
            </p>
            <p className="text-sm text-[#666666] mt-3 leading-relaxed max-w-xs">
              Enterprise-level AI education. No hype. No hand-waving. Just honest, practical understanding.
            </p>
          </div>
          <div>
            <p className="font-mono-plex text-xs tracking-[0.2em] uppercase text-[#666666] mb-4">
              Navigate
            </p>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-[#0A0A0A] link-underline w-fit">Home</Link>
              <Link to="/library" className="text-sm text-[#0A0A0A] link-underline w-fit">Library</Link>
              <Link to="/author" className="text-sm text-[#0A0A0A] link-underline w-fit">Author</Link>
              <Link to="/read/what-ai-is-not" className="text-sm text-[#0A0A0A] link-underline w-fit">Read Now</Link>
            </div>
          </div>
          <div>
            <p className="font-mono-plex text-xs tracking-[0.2em] uppercase text-[#666666] mb-4">
              Connect
            </p>
            <a
              href="https://shadabrashid.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#0A0A0A] link-underline"
            >
              shadabrashid.com
            </a>
          </div>
        </div>
        <div className="border-t border-[#E5E5E5] mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#666666]">
            &copy; {new Date().getFullYear()} Shadab Rashid. All rights reserved. The AI Mastery Series.
          </p>
          <p className="text-xs text-[#666666]">
            Entrepreneur &middot; AI Educator &middot; Founder, Flynaut
          </p>
        </div>
      </div>
    </footer>
  );
}
